import Default from "./VariableDisplayer";
export * from "./VariableDisplayer";

export default Default;
